import { FoxBizRequest, FoxRestBizClient } from "@/api/client";
import axios from "axios";

/**
 * 공통 기능 클래스
 */
class Common {

    /**
     * 생성자
     */
    constructor() {
    }

    /**
     * 암호화, 복호화 키 조회 메서드
     */
    getSirenPhoneSecString() {
        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Common.Biz.CommonBiz';
            request.methodId = 'GetSirenPhoneSecString';

            service.execute(request).then(response => {

                const reqInfo = response;

                if (!!reqInfo) resolve(reqInfo);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 암호화 -> 복호화 메서드
     * @param {String} requestNum 
     * @param {String} resulttInfo 
     * @returns 
     */
     setSirenPhoneSecString(requestNum, resulttInfo) {
        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Common.Biz.CommonBiz';
            request.methodId = 'SetSirenPhoneSecString';
            request.parameters.requestNum = requestNum
            request.parameters.resulttInfo = resulttInfo

            service.execute(request).then(response => {

                if (!!response) resolve(response.data.result.value);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 공통 프로그램 목록 조회
     * @param {string} keyword
     * @returns 
     */
    GetProjectSelect(keyword) {
        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Cims.Biz.CimsPrjInfoBiz';
            request.methodId = 'GetProject';
            request.parameters.keyword = keyword

            service.execute(request).then(response => {

                const rows = response.data.result.value.Table.rows;

                if (!!rows.length) resolve(rows);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 공통 시스템코드 정보 가져오기
     * @param {string} boardInfo 
     * @param {string} searchVal 
     * @returns 
     */
    getSystemCodeInfo(boardInfo, searchVal) {
        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Admin.Biz.CodeBiz';
            request.methodId = 'GetCodeInfoByBoardInfo';
            request.parameters.boardInfo = boardInfo
            request.parameters.searchVal = searchVal

            service.execute(request).then(response => {

                const rows = response.data.result.value.Table.rows;

                if (!!rows.length) resolve(rows);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * client ip 가져오기
     * @returns 
     */
    async getClientIp() {

        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            return response.data.ip;
        }
        catch (error) {

            return null;
        }
    }
}

export const common = new Common();